
var digitalData = digitalData || {};
digitalData.page = digitalData.page || {}; 				// Information of the page access by consumer
digitalData.product = digitalData.product || {}; 				// Information of product accees or purchesed by consumer.
digitalData.consumer = digitalData.consumer || {}; 				// Information about the consumer
digitalData.transaction = digitalData.transaction || {};				// Information of Order or application made by consumer.
digitalData.event = digitalData.event || {};				// ClickStream events made by consumer.
digitalData.system = digitalData.system || {};              //contain the information which provided by the system not fill by user.
digitalData.version = "v1.0"

// To be invoked on every page load. Initialises page section of data layer object.
function initiPageInfo(siteSection, siteSubSection, server, productId, productName, consumerType) {
    try {
        digitalData.page.siteSection = siteSection || "",
            digitalData.page.siteSubSection = siteSubSection || "",
            digitalData.page.server = server || "",
            digitalData.product.productId = productId || "",
            digitalData.consumer.type = consumerType || ""
        digitalData.product.productName  = productName || "",
            digitalData.event.eventId = "pageInitialization"
    }
    catch (err) { }
}

//To be invoked when new Application is created.
function applicationCreated(applicationKey, mobileNo, dob, insuringFor, pinCode, city, appQuoteCriteriaId, productId, productName, processId, nextTaskKey, stagePercentage) {
    try {
        digitalData.consumer = digitalData.consumer || {},
            digitalData.consumer.contact = digitalData.consumer.contact || {},
            digitalData.event.eventContext = digitalData.event.eventContext || {},
            digitalData.consumer.applicationKey = applicationKey || "",
            digitalData.consumer.contact.mobileNo = mobileNo == undefined ? "" : window.btoa(mobileNo),
            digitalData.consumer.dob = dob || "",
            digitalData.event.eventContext.city = city || "",
            digitalData.event.eventContext.pinCode = pinCode || "",
            digitalData.event.eventContext.insuringFor = insuringFor || "",
            digitalData.consumer.appQuoteCriteriaId = appQuoteCriteriaId || "",
            digitalData.product.productId = productId || "",
            digitalData.product.productName = productName || "",
            digitalData.consumer.processId = processId || "",
            digitalData.system.nextTaskKey = nextTaskKey || "",
            digitalData.system.stagePercentage = stagePercentage || "",
            digitalData.event.eventId = "application Created",
            callStatellite("omnichannel-health-application-created-success")
    }
    catch (err) { }

}
//To be invoked when Application is Resume.
function applicationResumeStart(applicationKey, mobileNo, dob, pinCode, insuringFor, appQuoteCriteriaId, productId, productName, processId, nextTaskKey, stagePercentage, applicantId, planDetail, topUpDetails) {
    try {
        digitalData.consumer = digitalData.consumer || {},
            digitalData.consumer.contact = digitalData.consumer.contact || {},
            digitalData.event.eventContext = digitalData.event.eventContext || {},
            digitalData.consumer.applicationKey = applicationKey || "",
            digitalData.consumer.contact.mobileNo = mobileNo == undefined ? "" : window.btoa(mobileNo),
            digitalData.consumer.dob = dob || "",
            digitalData.event.eventContext.pinCode = pinCode || "",
            digitalData.event.eventContext.insuringFor = insuringFor || "",
            digitalData.consumer.appQuoteCriteriaId = appQuoteCriteriaId || "",
            digitalData.product.productId = productId || "",
            digitalData.product.productName = productName || "",
            digitalData.consumer.processId = processId || "",
            digitalData.transaction.cart = digitalData.transaction.cart || {},
            digitalData.transaction.cart.item = digitalData.transaction.cart.item || {},
            digitalData.transaction.cart.item.planDetail = planDetail || "",
            digitalData.transaction.cart.item.topUpDetails = topUpDetails || "",
            digitalData.system.nextTaskKey = nextTaskKey || "",
            digitalData.system.stagePercentage = stagePercentage || "",
            digitalData.event.eventId = "applicationResumeStart",
            callStatellite("omnichannel-health-application-resume-start")

    }
    catch (err) { }

}

//To be invoked when application resueme is completed.
function applicationResumeCompleted(applicationKey, mobileNo, dob, insuringFor, pinCode, appQuoteCriteriaId, productId, productName, resumeWithOTP, processId, nextTaskKey, stagePercentage, planDetail, topUpDetails) {
    try {
        digitalData.consumer = digitalData.consumer || {},
            digitalData.consumer.contact = digitalData.consumer.contact || {},
            digitalData.event.eventContext = digitalData.event.eventContext || {},
            digitalData.consumer.applicationKey = applicationKey || "",
            digitalData.consumer.applicantId = applicantId || "",
            digitalData.consumer.contact.mobileNo = mobileNo == undefined ? "" : window.btoa(mobileNo),
            digitalData.consumer.dob = dob || "",
            digitalData.event.eventContext.pinCode = pinCode || "",
            digitalData.event.eventContext.insuringFor = insuringFor || "",
            digitalData.consumer.appQuoteCriteriaId = appQuoteCriteriaId || "",
            digitalData.product.productId = productId || "",
            digitalData.product.productName = productName || "",
            digitalData.consumer.processId = processId || "",
            digitalData.transaction.cart = digitalData.transaction.cart || {},
            digitalData.transaction.cart.item = digitalData.transaction.cart.item || {},
            digitalData.transaction.cart.item.planDetail = planDetail || "",
            digitalData.transaction.cart.item.topUpDetails = topUpDetails || "",
            digitalData.system.nextTaskKey = nextTaskKey || "",
            digitalData.system.stagePercentage = stagePercentage || "",
            digitalData.event.eventContext.resumeWithOTP = resumeWithOTP || "",
            digitalData.event.eventId = "applicationResumeComplete",
            callStatellite("omnichannel-health-application-resume-complete")

    }
    catch (err) { }

}



//Shows all lists of plans for customer to choose relevant plan
//please pass entire array of planlist in planList Variable
function planListingDisplayed(applicationKey, quoteID, quoteIds, planList, emiCardEligibility, processId, nextTaskKey, stagePercentage) {
    try {
        digitalData.consumer = digitalData.consumer || {},
            digitalData.event.eventContext = digitalData.event.eventContext || {},
            digitalData.consumer.applicationKey = applicationKey || "",
            digitalData.consumer.quoteID = quoteID || "",
            digitalData.consumer.processId = processId || "",
            digitalData.consumer.quoteIds = quoteIds || "",
            digitalData.product.planList = planList || {},
            digitalData.consumer.emiCardEligibility = emiCardEligibility || "",
            digitalData.system.nextTaskKey = nextTaskKey || "",
            digitalData.system.stagePercentage = stagePercentage || "",
            digitalData.event.eventId = "plan Listing Displayed",
            callStatellite("omnichannel-health-plan-listing-displayed")
    }
    catch (err) { }

}

function refinement(applicationKey, quoteID, changeType, changePosition, planList, emiCardEligibility) {
    try {
        digitalData.consumer = digitalData.consumer || {},
            digitalData.event.eventContext = digitalData.event.eventContext || {},
            digitalData.consumer.applicationKey = applicationKey || "",
            digitalData.consumer.quoteID = quoteID || "",
            digitalData.event.eventContext.changeType = changeType || "",
            digitalData.event.eventContext.changePosition = changePosition || "",
            digitalData.product.planList = planList || {},
            digitalData.consumer.emiCardEligibility = emiCardEligibility || "",
            digitalData.event.eventId = "plan refinement",
            callStatellite("omnichannel-health-plan-refinement")
    }
    catch (err) { }

}

/*
//when customer is editing Vehicle Details/Registration Number/Policy Coverage Details
function detailsEdit(applicationKey,detailsEditType,stageWhereEditInitiated,nextTaskKey){

    digitalData.event.eventContext=digitalData.event.eventContext||{},
    digitalData.consumer.applicationKey=applicationKey||"",
    digitalData.event.eventContext.detailsEditType=detailsEditType||"",
    digitalData.event.eventContext.stageWhereEditInitiated=stageWhereEditInitiated||"",
    digitalData.system.nextTaskKey=nextTaskKey||"",
    digitalData.event.eventId="details edit",
    callStatellite("omnichannel-details-edit")
}
*/


//customer selects product and quote is created

function quoteCreated(applicationKey, quoteID, planDetail, topUpDetails, sumInsured, premiumAmount, tenure, processId, nextTaskKey, stagePercentage) {
    digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer.applicationKey = applicationKey || "",
        digitalData.consumer.quoteID = quoteID || "",
        digitalData.transaction.cart = digitalData.transaction.cart || {},
        digitalData.transaction.cart.item = digitalData.transaction.cart.item || {},
        digitalData.transaction.cart.item.planDetail = planDetail || "",
        digitalData.transaction.cart.item.topUpDetails = topUpDetails || "",
        digitalData.transaction.cart.amount = digitalData.transaction.cart.amount || {},
        digitalData.transaction.cart.amount.premiumAmount = premiumAmount || "",
        digitalData.transaction.cart.amount.sumInsured = sumInsured || "",
        digitalData.event.eventContext.tenure = tenure || "",
        // digitalData.event.eventContext.panIndiaCoverage=panIndiaCoverage||"",
        digitalData.consumer.processId = processId || "",
        digitalData.system.nextTaskKey = nextTaskKey || "",
        digitalData.system.stagePercentage = stagePercentage || "",
        digitalData.event.eventId = "policy quote created",
        callStatellite("omnichannel-health-policy-quote-created")
}


//proposer detail capture page
function proposerDetailsCreated(applicationKey, quoteID, firstName, lastName, emailID, dob, mobileNo, gender, emiCardEligibility, processId, nextTaskKey, stagePercentage) {
    digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer.contact = digitalData.consumer.contact || {},
        digitalData.consumer.proposer = digitalData.consumer.proposer || {},
        digitalData.consumer.applicationKey = applicationKey || "",
        digitalData.consumer.quoteID = quoteID || "",
        digitalData.consumer.proposer.mobileNo = mobileNo == undefined ? "" : window.btoa(mobileNo),
        digitalData.consumer.proposer.emailID = emailID == undefined ? "" : window.btoa(emailID),
        digitalData.consumer.proposer.firstName = firstName || "",
        digitalData.consumer.proposer.lastName = lastName || "",
        digitalData.consumer.proposer.dob = dob || "",
        digitalData.consumer.proposer.gender = gender || "",
        digitalData.consumer.processId = processId || "",
        digitalData.system.nextTaskKey = nextTaskKey || "",
        digitalData.consumer.emiCardEligibility = emiCardEligibility || "",
        digitalData.system.stagePercentage = stagePercentage || "",
        digitalData.event.eventId = "proposer Details Created",
        callStatellite("omnichannel-health-proposer-details-created")
}

//Initiate payment
function paymentStarted(applicationKey, quoteID, paymentInstrument, systemPaymentId, processId, nextTaskKey, stagePercentage) {
    digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer.applicationKey = applicationKey || "",
        digitalData.consumer.quoteID = quoteID || "",
        digitalData.event.eventContext.paymentInstrument = paymentInstrument || "",
        digitalData.transaction.systemPaymentId = systemPaymentId || "",
        digitalData.consumer.processId = processId || "",
        digitalData.system.nextTaskKey = nextTaskKey || "",
        digitalData.system.stagePercentage = stagePercentage || "",
        digitalData.event.eventId = "payment started",
        callStatellite("omnichannel-payment-started")
}

//Complete payment
function paymentCompleted(applicationKey, quoteID, planDetail, topUpDetails, paymentInstrument, systemPaymentId, referenceNumber, orderId, paymentId, orderAmount, gstAmount, processId, nextTaskKey, stagePercentage) {
    digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.transaction.cart = digitalData.transaction.cart || {},
        digitalData.transaction.cart.amount = digitalData.transaction.cart.amount || {},
        digitalData.transaction.cart.item = digitalData.transaction.cart.item || {},
        digitalData.consumer.applicationKey = applicationKey || "",
        digitalData.consumer.quoteID = quoteID || "",
        digitalData.event.eventContext.paymentInstrument = paymentInstrument || "",
        digitalData.event.eventContext.referenceNumber = referenceNumber || "",
        digitalData.event.eventContext.paymentId = paymentId || "",
        digitalData.transaction.systemPaymentId = systemPaymentId || "",
        digitalData.transaction.cart.amount.orderAmount = orderAmount || "",
        digitalData.transaction.cart.amount.gstAmount = gstAmount || "",
        //digitalData.transaction.cart.item.planDetail=planDetail||"",
        //digitalData.transaction.cart.item.topUpDetails=topUpDetails||"",
        digitalData.transaction.orderId = orderId || "",
        digitalData.consumer.processId = processId || "",
        digitalData.system.nextTaskKey = nextTaskKey || "",
        digitalData.system.stagePercentage = stagePercentage || "",
        digitalData.event.eventId = "payment completed",
        callStatellite("omnichannel-payment-completed")
}

// when payment is failed
function paymentFailed(applicationKey, quoteID, planDetail, topUpDetails, rejectReason, paymentInstrument, processId, nextTaskKey, stagePercentage) {
    digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer.applicationKey = applicationKey || "",
        digitalData.consumer.quoteID = quoteID || "",
        digitalData.event.eventContext.paymentInstrument = paymentInstrument || "",
        digitalData.event.eventContext.rejectReason = rejectReason || "",
        digitalData.transaction.cart = digitalData.transaction.cart || {},
        digitalData.transaction.cart.item = digitalData.transaction.cart.item || {},
        //digitalData.transaction.cart.item.planDetail=planDetail||"",
        //digitalData.transaction.cart.item.topUpDetails=topUpDetails||"",
        digitalData.consumer.processId = processId || "",
        digitalData.system.nextTaskKey = nextTaskKey || "",
        digitalData.system.stagePercentage = stagePercentage || "",
        digitalData.event.eventId = "payment failed",
        callStatellite("omnichannel-payment-failed")

}


// after payment and  click on proceed button
function proceedAfterPayment(applicationKey, quoteID, processId, nextTaskKey, stagePercentage) {
    digitalData.consumer.applicationKey = applicationKey || "",
        digitalData.consumer.quoteID = quoteID || "",
        digitalData.consumer.processId = processId || "",
        digitalData.system.nextTaskKey = nextTaskKey || "",
        digitalData.system.stagePercentage = stagePercentage || "",
        digitalData.event.eventId = "proceed After Payment",
        callStatellite("omnichannel-proceed-after-payment")
}

//insured detail capture page
function insuredDetailsCreated(applicationey, applicantId, quoteID, firstName, lastName, emailID, dob, mobileNo, gender, processId, nextTaskKey, stagePercentage) {
    digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer.contact = digitalData.consumer.contact || {},
        digitalData.consumer.insuredDetails = digitalData.consumer.insuredDetails || {},
        digitalData.consumer.applicationey = applicationey || "",
        digitalData.consumer.applicantId = applicantId || "",
        digitalData.consumer.quoteID = quoteID || "",
        digitalData.consumer.insuredDetails.mobileNo = mobileNo == undefined ? "" : window.btoa(mobileNo),
        digitalData.consumer.insuredDetails.emailID = emailID == undefined ? "" : window.btoa(emailID),
        digitalData.consumer.insuredDetails.firstName = firstName || "",
        digitalData.consumer.insuredDetails.lastName = lastName || "",
        digitalData.consumer.insuredDetails.dob = dob || "",
        digitalData.consumer.insuredDetails.gender = gender || "",
        digitalData.consumer.processId = processId || "",
        digitalData.system.nextTaskKey = nextTaskKey || "",
        digitalData.system.stagePercentage = stagePercentage || "",
        digitalData.event.eventId = "insured Details Created",
        callStatellite("omnichannel-health-insured-details-created")
}



//Address detail capture page
function addressDetailsCreated(applicationKey, applicantId, quoteID, addressId, addressType, address1, address2, pincode, city, state, processId, nextTaskKey, stagePercentage) {
    digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer.applicationKey = applicationKey || "",
        digitalData.consumer.applicantId = applicantId || "",
        digitalData.consumer.quoteID = quoteID || "",
        digitalData.event.eventContext.addressId = addressId || "",
        digitalData.event.eventContext.addressType = addressType || "",
        digitalData.event.eventContext.address1 = address1 || "",
        digitalData.event.eventContext.address2 = address2 || "",
        digitalData.event.eventContext.pinCode = pincode || "",
        //digitalData.event.eventContext.city=city||"",
        digitalData.event.eventContext.state = state || "",
        digitalData.consumer.processId = processId || "",
        digitalData.system.nextTaskKey = nextTaskKey || "",
        digitalData.system.stagePercentage = stagePercentage || "",
        digitalData.event.eventId = "address details created",
        callStatellite("omnichannel-address-details-created")
}

//nominee Details Capture page
function nomineeDetailsCreated(applicationKey, applicantId, quoteID, firstName, lastName, relationship, processId, nextTaskKey, stagePercentage) {
    digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer.applicationKey = applicationKey || "",
        digitalData.consumer.applicantId = applicantId || "",
        digitalData.consumer.quoteID = quoteID || "",
        digitalData.event.eventContext.nomineeFirstName = firstName || "",
        digitalData.event.eventContext.nomineeLastName = lastName || "",
        digitalData.event.eventContext.relationship = relationship || "",
        digitalData.consumer.processId = processId || "",
        digitalData.system.nextTaskKey = nextTaskKey || "",
        digitalData.system.stagePercentage = stagePercentage || "",
        digitalData.event.eventId = "nominee Details Created",
        callStatellite("omnichannel-nominee-details-created")
}


function healthDeclarationCreated(applicationKey, applicantId, quoteID, healthDeclarationFlag, processId, nextTaskKey, stagePercentage) {
    digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer.applicationKey = applicationKey || "",
        digitalData.consumer.applicantId = applicantId || "",
        digitalData.consumer.quoteID = quoteID || "",
        digitalData.event.eventContext.healthDeclarationFlag = healthDeclarationFlag || "",
        digitalData.consumer.processId = processId || "",
        digitalData.system.nextTaskKey = nextTaskKey || "",
        digitalData.system.stagePercentage = stagePercentage || "",
        digitalData.event.eventId = "healthDeclarationCreated",
        callStatellite("omnichannel-health-declaration-created")
}

// issue policy start

function policyBookingStarted(applicationKey, applicantId, quoteID, goGreenFlag, processId, nextTaskKey, stagePercentage) {
    digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer.applicationKey = applicationKey || "",
        digitalData.consumer.applicantId = applicantId || "",
        digitalData.consumer.quoteID = quoteID || "",
        digitalData.consumer.processId = processId || "",
        digitalData.system.nextTaskKey = nextTaskKey || "",
        digitalData.event.eventContext.goGreenFlag = goGreenFlag || "",
        digitalData.system.stagePercentage = stagePercentage || "",
        digitalData.event.eventId = "policy booking started",
        callStatellite("omnichannel-policy-booking-started")
}

//issue policy complete
function policyIssued(applicationKey, quoteID, policyStatus, policyObj, processId, nextTaskKey, stagePercentage) {
    digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer.applicationKey = applicationKey || "",
        digitalData.consumer.quoteID = quoteID || "",
        digitalData.event.eventContext.policyStatus = policyStatus || "",
        digitalData.event.eventContext.policyObject = policyObj || "",
        // digitalData.consumer.quoteItemId=quoteItemId,
        // digitalData.event.eventContext.policyType=policyType||"",
        // digitalData.consumer.policyNo=policyNo||"",
        digitalData.consumer.processId = processId || "",
        digitalData.system.nextTaskKey = nextTaskKey || "",
        digitalData.system.stagePercentage = stagePercentage || "",
        digitalData.event.eventId = "policy issued",
        callStatellite("omnichannel-policy-issued")
}

//when back is pressed
function backButton(applicationKey, stageWhereBackInitiated, nextTaskKey, stagePercentage) {
    digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer.applicationKey = applicationKey || "",
        digitalData.event.eventContext.stageWhereBackInitiated = stageWhereBackInitiated || ""
    digitalData.system.nextTaskKey = nextTaskKey || "",
        digitalData.system.stagePercentage = stagePercentage || "",
        digitalData.event.eventId = "back button click",
        callStatellite("omnichannel-back-button-click")
}


//click on Explore more products
function exploreMoreProducts(applicationKey, quoteID, currentStage, destinationURL) {
    digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer.applicationKey = applicationKey || "",
        digitalData.consumer.quoteID = quoteID || "",
        digitalData.system.currentStage = currentStage || "",
        digitalData.event.eventContext.destinationURL = destinationURL || "",
        digitalData.event.eventId = "explore More Products",
        callStatellite("omnichannel-explore-more-products")
}

//	click on cross sell products
function crossellProducts(applicationKey, quoteID, currentStage, productCode, productName, bannerName, bannerPosition, bannerDiscription, destinationURL) {
    digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer.applicationKey = applicationKey || "",
        digitalData.consumer.quoteID = quoteID || "",
        digitalData.system.currentStage = currentStage || "",
        digitalData.event.eventContext.crosSell = digitalData.event.eventContext.crosSell || {},
        digitalData.event.eventContext.crosSell.productCode = productCode || "",
        digitalData.event.eventContext.crosSell.productName = productName || "",
        digitalData.event.eventContext.bannerName = bannerName || "",
        digitalData.event.eventContext.bannerPosition = bannerPosition || "",
        digitalData.event.eventContext.bannerDiscription = bannerDiscription || "",
        digitalData.event.eventContext.destinationURL = destinationURL || "",
        digitalData.event.eventId = "cros sell Products",
        callStatellite("omnichannel-cros-sell-product")
}

// To be invoked of an API Failure.
function triggerAPIFailure(errorCode, errorName, apiName) {
    try {
        digitalData.system.error = digitalData.system.error || {},
            digitalData.system.error.errorCode = errorCode || "",
            digitalData.system.error.errorName = errorName || "",
            digitalData.system.error.apiName = apiName || "",
            callStatellite("omnichannel-api-failure")
    }
    catch (err) { }
}

// common function for _satellite
function callStatellite(eventName) {
    try {
        _satellite.track(eventName);
    } catch (err) { }
}
